export const validateNIC = (nic) => {
    const oldNICPattern = /^[0-9]{9}[vVxX]$/; // Old NIC Format (9 digits + 'V' or 'X')
    const newNICPattern = /^[0-9]{12}$/; // New NIC Format (12 digits)

    return oldNICPattern.test(nic) || newNICPattern.test(nic);
};

export const validateName = (name) => {
    return /^[A-Za-z\s]{3,50}$/.test(name); // ✅ Only letters & spaces, 3-50 chars
};

export const validateDOB = (dob) => {
    const today = new Date();
    const inputDate = new Date(dob);
    return inputDate < today; // ✅ DOB must be in the past
};

export const validateAddress = (address) => {
    return address.length >= 5 && address.length <= 100; // ✅ Min 5, Max 100 chars
};

export const validatePhoneNumber = (phone) => {
    return /^(0[1-9][0-9]{8})$/.test(phone); // ✅ Must start with '0', 10 digits total
};
